import React from "react";
import { Card, Spinner, Stack, Icon, Text } from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";
import { ArrowUpMinor, ArrowDownMinor } from "@shopify/polaris-icons";
import { useTranslation } from "react-i18next";
import lmsAPI from "../../services/lmsAPI";

export default function CardList(props) {
  const { t } = useTranslation();
  const { url, dataKey, dashboardParams, title, height } = props;

  const { data, isError, isFetching } = useQuery(
    ["analytics", dataKey, dashboardParams],
    () => fetchData(dashboardParams)
  );

  async function fetchData(params) {
    const res = await lmsAPI.get(url, { params: params });
    return res.data;
  }

  if (!data) return null;

  const dataSets = data;

  // Return null unless all datasets have the same keys

  const comparisonDatasets = dataSets.filter((ds) => ds.isComparison);
  const nonComparisonDatasets = dataSets.filter((ds) => !ds.isComparison);

  // If there are isComparison data sets, sum them and compare agains the non comparison datasets

  return (
    <Card title={title} sectioned>
      <div style={{}}>
        {isError && <p>{t("common.error")}</p>}
        {isFetching && (
          <div
            style={{
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner size="large" />
          </div>
        )}
        {!nonComparisonDatasets.map((dataSet) => dataSet.data).flat()
          .length && <Text  variant="bodyMd" as="span" color="subdued">{t("common.noData")}</Text>}

        {data && !isFetching && (
          <div>
            {nonComparisonDatasets.map((dataSet) => (
              <>
                <div className="card-list-data">
                  {dataSet.data.map((entry) => {
                    let comparisonData = null;
                    comparisonDatasets.forEach((ds) =>
                      ds.data.forEach((comparisonEntry) => {
                        if (comparisonEntry.key == entry.key) {
                          comparisonData = comparisonEntry.value;
                        }
                      })
                    );
                    return <>
                      <div className="data-key">
                        <Text variant="bodyMd" as="span">{entry.key}</Text>
                      </div>
                      <div className="data-value">
                        <Text variant="bodyMd" as="span">{entry.value}</Text>
                      </div>
                      {comparisonData != null && (
                        <div className="data-comparison">
                          <ComparisonPercent
                            comparison={comparisonData}
                            current={entry.value}
                          />
                        </div>
                      )}
                    </>;
                  })}
                </div>
              </>
            ))}
          </div>
        )}
      </div>
    </Card>
  );
}

function ComparisonPercent({ comparison, current }) {
  const percentChange = (parseFloat(current) / parseFloat(comparison)) * 100;
  if (comparison == 0) {
    return (
      <Stack alignment="center" distribution="trailing">
        <Text  variant="bodyMd" as="span" color="subdued">-</Text>
      </Stack>
    );
  }
  return (
    <Stack alignment="center" spacing="extraTight" distribution="trailing">
      {current > comparison ? (
        <Icon source={ArrowUpMinor} color="success" />
      ) : (
        <Icon source={ArrowDownMinor} color="critical" />
      )}

      <Text variant="bodyMd" as="span">{parseInt(percentChange)}%</Text>
    </Stack>
  );
}

// [
//   {
//     name: "BCFM 2021",
//     data: [
//       {
//         key: "Womens Leggings",
//         value: 7,
//       },
//       {
//         key: "Mens Bottoms",
//         value: 0,
//       },
//       {
//         key: "Mens Shorts",
//         value: 6,
//       },
//       {
//         key: "Socks",
//         value: 12,
//       },
//       {
//         key: "Hats",
//         value: 50,
//       },
//       {
//         key: "Ties",
//         value: 5,
//       },
//     ],
//   },
// ];
